import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { ColDef } from 'ag-grid-community';
import { FeiKeyDef } from '@wizeoo/akm-compute-lib';

import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { FreedataFormWidget } from '../freedata-form.widget';

/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface FreedataFormChooserVO {
  context: WidgetConfigurationObj; // la configuration
  updateCallback: Function; // la callback pour retour
  pivot: FreedataFormWidget; // le pivot source pour prise en compte du mode "conf"
  sourceDS:  WizDatasource<FreedataValueVO>; // la liste source
}



@Component({
  // popUp de sélection du FDV à éditer
  selector: 'freedata-form-choose-pop',
  templateUrl: './freedata-form-choose.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataFormChoosePop extends WizBasePopUp {
  @ViewChild('liKey', { read: WizAgGrid, static: false }) liKey: WizAgGrid<FreedataValueVO>; // la liste contenant les valeurs de clés
  @ViewChild('fdvFilter', { read: FilterComponent }) fdvFilter: FilterComponent; // filtre des mesures

  public declare datas: FreedataFormChooserVO;
  public static baseWidth: number = 500;
  public static baseHeight: number = 300;

  public fdvDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>([]) // DS de la liste
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();

  // colonne du grid des roles du profil
  public keyGridColumns: ColDef[] = [
    { headerName: '$.field.shortcode.$', width: 100, sortable: true, field: 'shortCode' },
    { headerName: '$.field.parentcode.$', width: 100, sortable: true, field: 'parentCode' },
    { headerName: '$.field.label.$', flex: 1, sortable: true, field: 'trsLabelWithParent', tooltipField: 'trsLabelWithParent' },
  ];


  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    this.feedDatasources();
    this.addListeners();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
  
    this.fdvDS.setSource(this.datas.sourceDS.getWorkedSource());
    this.fdvDS.select(this.datas.sourceDS.selectedItems);
    // construction du filtre
    this.fdvFilter.configure(['code', 'parentCode', 'trsLabel', 'trsLabelWithParent'], null, null).build();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.fdvFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre des mesures & function
  }

  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: FeiKeyDef): boolean {
    return this.fdvFilter.checkVisible(item);
  }

  /**
   * modification du filtre des fdv
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.fdvDS.refresh();
  }

  /** Sauvegarde, même valeur */
  public save(): void {
    let val: FreedataValueVO = this.fdvDS.selectedItem;
    this.datas.updateCallback(val);
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public hide() {
    WizEventManager.removeListener(this, this.fdvFilter, WIZ_EVENT_TYPE.FILTER);
    super.hide();
  }
}
